<template>
  <div class="user-main-left fl">
    <dl class="navigation-sub">
      <dt>关于我们</dt>
      <dd :class="{'syy-navigation-sub-active':aboutUserNav==1}" @click="aboutUserFun(1)">学校简介</dd>
      <dd :class="{'syy-navigation-sub-active':aboutUserNav==2}" @click="aboutUserFun(2)">意见反馈</dd>
    </dl>
  </div>
</template>

<script>
  export default {
    name: "about-user",
    computed:{
    },
    props: {
      aboutUserNav:{
        type: Number,
        default: 1
      }, //当前页导航
    },
    methods: {
      /* 跳转我的页面 */
      aboutUserFun (e,num) {
        switch (e) {
          case 1:
            this.$router.push({
              path: `/aboutuser/brief`,
            });
            break;
          case 2:
            this.$router.push({
              path: `/aboutuser/feedback`,
            });
            break;
        }
        this.$emit('getData')
      },
    }
  }
</script>

<style scoped>
  .fl{
    float: left;
  }
  .user-main-left{
    width: 165px;
    float: left;
    background: #ffffff;
    height: 720px;
    text-align: center;
  }
  .navigation-sub dt{
    font-size: 20px;
    color: #212121;
    margin-bottom: 19px;
    font-weight: 700;
    box-sizing: border-box;
    margin-top: 36px;
  }
  .navigation-sub dt:first-child{
    margin-top:38px;
  }
  .navigation-sub dd{
    font-size: 16px;
    color: #6f6f6f;
    margin-bottom: 19px;
    cursor: pointer;
    padding-left: 40px;
    text-align: left;
    box-sizing: border-box;
  }
  .navigation-sub .syy-navigation-sub-active{
    color: #1a71ff;
    border-left: 4px solid #1a71ff;
    padding-left: 36px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/about-user.vue